// @generated by TypeGen from LogbookModel/Ship.swift - DO NOT EDIT

import type { ILogbookModel, IModelCalculations } from "./Model"
import type { ISettings } from "./Settings"
import type { IShipData } from "./Settings/ShipData"
import type { IShipSettings } from "./Settings/ShipSettings"
import type { IShipMetadata } from "./Ship/ShipMetadata"
import type { IShipUser } from "./ShipUser"

export interface IShip extends ILogbookModel {
  id: number;
  accountId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  clientToken?: string;
  data: string;
  engineCount: number;
  name: string;
  tenderToId?: number;
  vesselType: IShipVesselType;
  shipData?: IShipData;
  shipSettings?: IShipSettings;
}

export interface IShipCalculations extends IModelCalculations {
  day: number;
  course: number;
  lat: number;
  lng: number;
  lastSyncAt: string;
}

export interface IShipResponse {
  ship: IShip;
  primary: boolean;
  settings?: ISettings[];
  user?: IShipUser;
  users?: IShipUser[];
}

export interface IShipsResponse {
  ships: IShip[];
  users?: IShipUser[];
  ownShipId?: number;
}

export enum IShipVesselType {
  undefined = 0,
  motor = 1,
  sailing = 2,
}

export type IShipParsed = Omit<IShip, "data"> & { dataParsed: IShipMetadata };

export const Ship = {
  parse(r: IShip): IShipParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as IShipParsed;
  },
};
